import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TooltipProvider } from '@sanctuary/ui';
import { AppErrorBoundary } from './components/app/AppErrorBoundary';
import { installDesktopApiFetchPatch } from './lib/api-base';
import { ensureRuntimeEnvLoaded } from './lib/load-runtime-env';
import { applyDesktopPlatformClasses } from './lib/platform';
import './styles/globals.css';

// Apply native-shell markers before React renders so title-bar safe areas do
// not flash at their web layout. macOS is the only platform that gets an inset.
applyDesktopPlatformClasses(document.documentElement);

installDesktopApiFetchPatch();

async function bootstrap() {
  // Must run before AuthProvider / auth client modules evaluate so Electron
  // does not fall back to the auto "Local User" provider.
  await ensureRuntimeEnvLoaded();

  const { default: App } = await import('./App');

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppErrorBoundary>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <TooltipProvider>
            <App />
          </TooltipProvider>
        </BrowserRouter>
      </AppErrorBoundary>
    </React.StrictMode>,
  );
}

void bootstrap();
